import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import FileSaver from "file-saver";
import { FC, useEffect, useState } from "react";
import { base64toBlob } from "../../utils/fileUtils";
import { useToastNotifications } from "../../utils/toastUtils";
import Mandate from "../Common/Mandate/Mandate";
import { useAppSelector } from "../../redux/hook";
import { GENDER_ITEMS } from "../../utils/constant";
import { templateMandate } from "./mandate.html";
import { CREATE_MANDATE_PNVT } from "../../graphql/graphql_information/mandate/mutation";
import {
  CreateMandatePnvt,
  CreateMandatePnvtVariables,
} from "../../graphql/graphql_information/mandate/types/CreateMandatePnvt";
import { informationClient } from "../../apolloClient";
import { CHECK_MANDATE_PNVT } from "../../graphql/graphql_information/mandate/query";
import { CheckMandatePnvt } from "../../graphql/graphql_information/mandate/types/CheckMandatePnvt";
import { useOpenFileBase64 } from "../customHooks/file/dowloadOrOpenFile";

const styles = makeStyles((theme) => ({
  contract: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    height: "100%",
  },
  circularProgress: {
    margin: "24px auto",
  },
  imageContainer: {
    height: 96,
    display: "flex",
    justifyContent: "center",
  },
  image: {
    maxHeight: "100%",
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: theme.spacing(2, 0),
  },
}));

const SignedMandate: FC = () => {
  const classes = styles();
  const [open, setOpen] = useState(false);
  const { legalRepresentative, company } = useAppSelector(
    (state) => state.information.myInformation,
  );
  const { downloadFileFromBase64 } = useOpenFileBase64();
  const { showErrorToast, showSuccessToast } = useToastNotifications();

  const handleClose = () => {
    setOpen(false);
  };

  const [checkMandate] = useLazyQuery<CheckMandatePnvt>(CHECK_MANDATE_PNVT, {
    client: informationClient,
    onCompleted: (data) => {
      setOpen(!!data.checkMandatePnvt);
    },
  });

  const [saveContract, { loading: saveSignatureLoading }] = useMutation<
    CreateMandatePnvt,
    CreateMandatePnvtVariables
  >(CREATE_MANDATE_PNVT, {
    client: informationClient,
    onCompleted: async (data) => {
      if (data?.createMandatePnvt) {
        handleClose();

        handleDownloadContract(data.createMandatePnvt);
        showSuccessToast({
          description: "Votre contrat a été créé avec succès.",
          title: "",
        });
      }
    },
    onError: (error) => {
      showErrorToast({
        description:
          "Une erreur s'est produite lors de la création du contrat.",
        title: "",
      });
    },
  });

  const sendSignature = (signatureData: string) => {
    if (!!signatureData) {
      saveContract({
        variables: { signature: signatureData },
      });
    }
  };

  const handleDownloadContract = (contratData64: string) => {
    // const signatureBlob = base64toBlob(contratData64, "application/pdf");
    // FileSaver.saveAs(
    //   signatureBlob,
    //   `Contrat_${company?.name || ""}_Sapheer.pdf`,
    // );
    downloadFileFromBase64(
      contratData64,
      `Contrat_${company?.name || ""}_Sapheer.pdf`,
    );
  };

  let title = "";
  if (legalRepresentative) {
    const { gender, firstname, name } = legalRepresentative;
    const result = GENDER_ITEMS.find((item) => item.id === gender);
    title = `${result?.label || ""} ${firstname || ""} ${name || ""}`;
  }

  useEffect(() => {
    checkMandate();
  }, []);

  return (
    <Box className={classes.contract}>
      <Box>
        <Mandate
          contractTemplate={templateMandate()}
          handleClose={handleClose}
          open={open}
          handleSendSignature={sendSignature}
          title={title}
          loading={saveSignatureLoading}
        />
      </Box>
    </Box>
  );
};

export default SignedMandate;
